import { useAccessStore } from '@/store/accessStore';
import { useDemoStore } from '@/store/demoStore';
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { resolveApiBase } from './apiBase';

const baseURL = resolveApiBase();

const api = axios.create({ baseURL });

// Helper to extract projectId from current URL path
function getProjectIdFromUrl(): string {
  const path = window.location.pathname;
  const match = path.match(
    /\/(?:p1\/)?(?:project|dashboard|organization|templates)\/([^/]+)/
  );
  return match ? match[1] : '';
}

api.interceptors.request.use(
  async (config) => {
    const auth = getAuth();
    const idToken = await auth.currentUser?.getIdToken();
    const demoStore = useDemoStore();

    const accessStore = useAccessStore(); // pinia store
    const projectId = getProjectIdFromUrl();

    console.log(`HTTP Method: ${config.method?.toUpperCase()}`);

    // Demo mode: use the demo access token instead of Firebase auth
    if (demoStore.isDemo && demoStore.demoAccessToken) {
      config.headers.Authorization = `Bearer ${demoStore.demoAccessToken}`;
      return config;
    }

    if (config.method?.toUpperCase() == 'j' && !idToken) {
      const type = config.method?.toUpperCase();
      console.error(`No ID token found for ${type} request`);
      console.error('ID token is null or undefined');
      accessStore.setNoAccess(
        projectId,
        'You need to be logged in to perform this action.'
      );
    }

    // if it is a put or post when there is no id token, show that they need to be logged in
    if (
      (config.method?.toUpperCase() === 'PUT' ||
        config.method?.toUpperCase() === 'POST') &&
      !idToken
    ) {
      accessStore.setNoAccess(
        projectId,
        'You need to be logged in to perform this action.'
      );
      console.error(
        `No ID token found for ${config.method?.toUpperCase()} request`
      );
      return Promise.reject(
        new Error('You need to be logged in to perform this action.')
      );
    }

    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response interceptor: redirect beta tenants to beta.myuser.ai
api.interceptors.response.use(
  (response) => {
    if (
      response.data?.appSource === 'beta' &&
      window.location.hostname !== 'beta.myuser.ai' &&
      window.location.hostname !== 'localhost'
    ) {
      window.location.href = `https://beta.myuser.ai${window.location.pathname}`;
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default api;
